import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/stockTypes`;

const getSupplierStockTypes = (supplierId) => {
  return fetchWrapper.get(`${baseUrl}/suggestion?supplierId=${supplierId}`);
};

const getStockTypesByStockClass = (classId) => {
  return fetchWrapper.get(`${baseUrl}?stockClassId=${classId}`);
};

export const stockTypesService = {
  getSupplierStockTypes,
  getStockTypesByStockClass,
};
